import { inject, Injectable } from "@angular/core";
import {
	AutoStakingTrackingState,
	AutoStakingTrackingStateService
} from "@modules/staking/domain/+state/auto-staking-tracking.state";
import { SegmentService } from "@main-services/segment.service";
import { Observable } from "rxjs";
import { RudderstackDynamicProperties, RudderstackService } from "@main-services/rudderstack.service";

@Injectable({
	providedIn: "root"
})
export class AutoStakingTrackingFacade {
	private readonly autoStakingTrackingStateService = inject(AutoStakingTrackingStateService);
	private readonly segmentService = inject(SegmentService);
	private readonly rudderstackService = inject(RudderstackService);

	public getState$(): Observable<AutoStakingTrackingState> {
		return this.autoStakingTrackingStateService.getState$();
	}

	public updateFlowStarted(flowStarted: string): void {
		this.autoStakingTrackingStateService.updateOverviewFlow(flowStarted);
	}

	public trackEvent(eventName: string, properties?: Partial<RudderstackDynamicProperties>): void {
		this.segmentService.track({
			name: eventName,
			properties: {
				opt_in: properties?.opt_in,
				flow: properties?.flow
			}
		});
		this.rudderstackService.track({
			name: eventName,
			properties: {
				opt_in: properties?.opt_in,
				flow: properties?.flow
			}
		});
	}
}
